<template>
    <div v-if="servermessages.length > 0">
        <ul class="messages alert alert-warning">
            <li v-for="message in servermessages" :key="message">
                {{ message }}    
            </li>                             
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        servermessages: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.messages {
    border: 1px solid #000000;
    list-style-type: none;
}
</style>